import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';

@Component({
  selector: 'app-mis-revisiones',
  templateUrl: './mis-revisiones.component.html',
  styleUrls: ['./mis-revisiones.component.css']
})
export class MisRevisionesComponent implements OnInit {
  subMenus: object[];
  title: string;
  db: EstacionesTVADB;
  revisiones: object;

  constructor(private router: Router) {
    this.title = 'Mis revisiones',
      this.db = new EstacionesTVADB();
  }

  checklistClick(idRevision) {
    this.router.navigate(['Configuracion/ChecklistConfiguracion', idRevision]);
  };

  ngOnInit() {
    this.loadSubMenu();
    MasterDB.getLocalRevisiones().then(result => {
      this.revisiones = result;
    });
  }
  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'SincronizarRevisiones',
        router: 'SincronizarRevisiones',
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'MisRevisiones',
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}
